import { Component, OnInit, Input } from '@angular/core';
import { UIRouter } from '@uirouter/core';
import { CheckoutService } from '../checkout.service';

@Component({
  templateUrl: './successVouchers.component.html',
  styleUrls: [
    './successVouchers.component.scss'
  ]
})
export class CheckoutSuccessVouchersComponent implements OnInit {
  @Input()
  public stateParams;

  constructor(
    private router: UIRouter,
    private checkoutService: CheckoutService
  ) {

  }

  public ngOnInit() {    
    if (window.localStorage.getItem('checkoutItems')) {
      window.localStorage.removeItem('checkoutItems');
    }
  }
  
  public handleGoToCheckout() {
    this.router.stateService.go('main.checkout.index',
      {
        code: null,
        header:
        {
          backTo: 'main.checkout.successVouchers'
        }
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/checkout/successVouchers/successVouchers.component.ts